import React from 'react'
import Popover from '@mui/material/Popover';
import { Link, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import './menu.css'


const Menu = ({ menu }) => {
    const location = useLocation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    React.useEffect(() => {
        handlePopoverClose();
    }, [location.pathname]);

    const isActive = (menuItem) => {
        if (!menuItem?.to) return false;
        const current = location.pathname.replace(/\/+$/, '') || '/';
        const target = menuItem.to.replace(/\/+$/, '') || '/';
        if (current === target) return true;
        if (Array.isArray(menuItem.proxyto)) {
            return menuItem.proxyto.some(p => (p?.to?.replace(/\/+$/, '') || '/') === current);
        }
        if (menuItem.proxyto?.to) {
            return (menuItem.proxyto.to.replace(/\/+$/, '') || '/') === current;
        }
        if (Array.isArray(menuItem.submenus)) {
            return menuItem.submenus.some(s => (s?.to?.replace(/\/+$/, '') || '/') === current);
        }
        return false;
    }

    if (menu.submenus && Array.isArray(menu.submenus) && menu.submenus.length != 0) {
        return <>
            <Box className="menu">
                <Box
                    className={'menu-iteme ' + (isActive(menu) ? 'bg-yellow  shadow black' : 'bg-light-gray')}
                    sx={{
                        transition: 'background-color 0.3s ease',
                        '&:hover': {
                            // Added !important to force override the css class
                            backgroundColor: isActive(menu) ? undefined : '#e0e0e0 !important'
                        }
                    }}
                    onClick={handlePopoverOpen}
                    onMouseEnter={handlePopoverOpen}
                >
                    {menu?.icon}
                </Box>
                <div className='dark-gray menu-text' dangerouslySetInnerHTML={{ __html: menu?.label }}></div>
                <Box>
                    <Popover
                        id="mouse-over-popover"
                        sx={{ p: 2, borderRadius: 10 }}
                        open={open}
                        anchorEl={anchorEl}
                        disableScrollLock
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                        slotProps={{
                            paper: {
                                sx: {
                                    p: 2,
                                    borderRadius: 3, // 3 = theme spacing
                                    m: 1,
                                },
                            },
                        }}
                    >
                        <Box
                            className="info-bar no-trasperant"
                            sx={(theme) => ({
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 2,
                                flexDirection: 'row',
                                maxWidth: 220,
                                maxHeight: '80vh',
                                overflowY: 'auto',
                                scrollbarWidth: 'none',
                                '&::-webkit-scrollbar': { display: 'none' },
                                margin: '-10px',
                                background: theme.palette.mode === 'dark' ? '#1e1e1e' : '#fff',
                                padding: '10px',
                                justifyContent: 'space-around',
                                borderRadius: 4
                            })}>
                            {(menu?.submenus || []).map((subItem, subIdx) => <Box key={subItem?.to || subIdx} width={'40%'}>
                                <Link to={subItem?.to} className='menu' onClick={handlePopoverClose}>
                                    <Box
                                        className={'menu-iteme ' + (isActive(subItem) ? 'bg-yellow  shadow black' : 'bg-light-gray')}
                                        sx={{
                                            transition: 'background-color 0.3s ease',
                                            '&:hover': {
                                                // Added !important to force override the css class
                                                backgroundColor: isActive(subItem) ? undefined : '#e0e0e0 !important'
                                            },
                                        }}
                                    >
                                        {subItem?.icon}
                                    </Box>
                                    <div className='dark-gray menu-text' dangerouslySetInnerHTML={{ __html: subItem?.label }}></div>
                                </Link>
                            </Box>)}
                        </Box>
                    </Popover>
                </Box>
            </Box>
        </>
    }

    return <Link to={menu?.to} className='menu'>
        <Box
            className={'menu-iteme ' + (isActive(menu) ? 'bg-yellow  shadow black' : 'bg-light-gray')}
            sx={{
                transition: 'background-color 0.3s ease',
                '&:hover': {
                    // Added !important to force override the css class
                    backgroundColor: isActive(menu) ? undefined : '#e0e0e0 !important'
                }
            }}
        >
            {menu?.icon}
        </Box>
        <div className='dark-gray menu-text' dangerouslySetInnerHTML={{ __html: menu?.label }}></div>
    </Link>



}
const SideBar = ({ menus }) => {
    return (

        <div className='card-bg side-bar' id="side-bar">
            <div className='menu-bar'>
                {menus?.map((menu, index) => (menu && (
                    <Menu key={menu?.to || index} menu={menu} />
                )))}
            </div>
        </div>
    )
}
export default SideBar